import GetByUserIdRequestModelBase from '../_generated/modelBases/get-by-user-id-request-model-base';

export default class GetByUserIdRequestModel extends GetByUserIdRequestModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
